import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { Util } from '../../utils/util.service';
import { GlobalState } from '../../global.state';

@Component( {
  selector: 'rip-trading-view-fundamentals',
  template: `
    <div class="tradingview-widget-container" style="height: 300px;" #containerDiv>
      <div class="tradingview-widget-container__widget"></div>

    </div>
    <div class="tradingview-widget-copyright">

      <!--        <span class="blue-text">{{ brandingLabel }}</span>-->
      by <a (click)="goToTradingView()" class="rip-link"> TradingView </a>
    </div>
  `,
} )

export class TradingViewFundamentalsComponent implements AfterViewInit, OnDestroy {

  @Output() errorLoading: EventEmitter<any> = new EventEmitter<any>();
  // allows for loading with any symbol
  @Input() symbol: string = '';
  @Input() height: number = 300;
  settings: any = {};
  // id for being able to check for errors using postMessage
  widgetId: string = '';
  private _messageListener: ( ( e: any ) => void ) | null = null;

  // wanted to be able to hide the widget if the symbol passed in was invalid (don't love their sad cloud face)
  @ViewChild( 'containerDiv', { static: false } ) containerDiv: ElementRef;

  constructor( private _elRef: ElementRef ) {
  }

  gotToTradingView() {
    Util.openExternalUrl( `https://www.tradingview.com/symbols/${ this.symbol }/` );
  }

  ngOnDestroy(): void {
    if ( this._messageListener ) {
      window.removeEventListener( 'message', this._messageListener );
      this._messageListener = null;
    }
  }

  ngAfterViewInit() {
    // need to do this in AfterViewInit because of the Input
    setTimeout( () => {
      this.widgetId = `${ this.symbol }_fundamnetals`;

      const dimension = this.height - 10;

      // postMessage listener for handling errors
      if ( !this._messageListener ) {
        this._messageListener = ( e: any ) => {
          if ( e && e.data ) {
            // console.log( e );
            const payload = e.data;
            if ( payload.name === 'tv-widget-no-data' && payload.frameElementId === this.widgetId ) {
              this.containerDiv.nativeElement.style.display = 'none';
              this.errorLoading.emit();
            }
          }
        };
        window.addEventListener( 'message', this._messageListener, false );
      }


      this.settings = {
        symbol: this.symbol,
        colorTheme: GlobalState.tradingViewColorTheme,
        isTransparent: false,
        largeChartUrl: '',
        displayMode: 'regular',
        height: dimension,
        width: dimension,
        autosize: true,
        locale: 'en',
      };
      const script = document.createElement( 'script' );
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-financials.js';
      script.async = true;
      script.id = this.widgetId;
      script.innerHTML = JSON.stringify( this.settings );
      this.containerDiv.nativeElement.appendChild( script );
      const brandingDiv = document.createElement( 'div' );
      brandingDiv.innerHTML = `
    <div class="tradingview-widget-copyright">
    <a (click)="goToTradingView()">
    <span class="blue-text">${ this.symbol } Fundamental Data</span></a>
              by TradingView
          </div>
`;

    } );
  }

  goToTradingView() {
    const url = `https://www.tradingview.com/`;
    Util.openExternalUrl( url );
  }

}
